import {
    animate, AnimationTriggerMetadata, transition, trigger, state, style
} from "@angular/animations";

export const fadeAnimation: AnimationTriggerMetadata = trigger("fadeAnimation", [
    // Standard use
    state("*", style({
        opacity: 1.0
    })),
    state("shown", style({
        opacity: 1.0
    })),
    state("hidden", style({
        opacity: 0.0
    })),
    transition("shown <=> hidden",
        animate("500ms ease")),
    // For use with ngIf
    transition(":enter", [
        style({
            opacity: 0.0
        }),
        animate("500ms", style({
            opacity: 1.0
        }))
    ]),
    transition(":leave", [
        style({
            opacity: 1.0
        }),
        animate("500ms", style({
            opacity: 0.0
        }))
    ])
]);
